import { render } from "./DriverDashboardItem.vue?vue&type=template&id=7f40f66a"
import script from "./DriverDashboardItem.vue?vue&type=script&lang=js"
export * from "./DriverDashboardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__